module.exports = __webpack_public_path__ + "static/assets/7beca3650c0b781c8bc8430a5ba1cf60.svg";